<p-dropdown [options]="years" [(ngModel)]="selectedYear" *ngIf="selectedYear" (onChange)="updateInvoices()">
</p-dropdown>
<p-table #invTable [value]="invoices" [columns]="cols" [rowHover]="true">
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of cols" [pSortableColumn]="col.field"
                [ngClass]="{'comment-column': col.field=='comment', 'school-column': col.field=='school.name', 'id-column': col.field=='id', 'currency-column': col.field=='currency.isoCode'}">
                <div>
                    <span>
                        {{col.header}}
                    </span>
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </div>
            </th>
        </tr>
        <tr>
            <th *ngFor="let col of cols">
                <input pInputText (input)="invTable.filter($any($event.target)?.value, 'invoiceNumber', 'contains')"
                    *ngIf="col.field=='invoiceNumber'" [style]="{'width': '100%'}">
                <input pInputText (input)="invTable.filter($any($event.target)?.value, 'comment', 'contains')"
                    *ngIf="col.field=='comment'" [style]="{'width': '100%'}">
                <p-multiSelect *ngIf="col.field=='school.name'" [options]="schoolNames"
                    [style]="{'min-width': '150px', 'width': '150px'}" [(ngModel)]="selectedSchoolNames"
                    (onChange)="invTable.filter($any($event)?.value, col.field, 'in')">
                </p-multiSelect>
                <input pInputText (input)="invTable.filter($any($event.target)?.value, 'studentName', 'contains')"
                    *ngIf="col.field=='studentName'" [style]="{'width': '100%'}">
                <p-multiSelect *ngIf="col.field=='currency.isoCode'" [options]="currencyIsoCodes"
                    [(ngModel)]="selectedCurrencyIsoCodes"
                    (onChange)="invTable.filter($any($event)?.value, col.field, 'in')">
                </p-multiSelect>
                <input pInputText (input)="invTable.filter($any($event.target)?.value, 'invoiceAmount', 'amount')"
                    *ngIf="col.field=='invoiceAmount'" [style]="{'width': '100%'}">
                <input pInputText (input)="invTable.filter($any($event.target)?.value, 'totalPaidAmount', 'amount')"
                    *ngIf="col.field=='totalPaidAmount'" [style]="{'width': '100%'}">
                <input pInputText (input)="invTable.filter($any($event.target)?.value, 'balance', 'amount')"
                    *ngIf="col.field=='balance'" [style]="{'width': '100%'}">
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-invoice>
        <tr class="ui-selectable-row">
            <td *ngIf="!invoice.lvmsId" [class.blue-booking]="invoice.isElb">
                <a routerLink="/management/edit-booking/{{invoice.bookingId}}">
                    {{invoice.bookingId}}
                </a>
            </td>
            <td *ngIf="invoice.lvmsId" [class.blue-booking]="invoice.isElb">
                <a routerLink="/management/edit-booking/{{invoice.bookingId}}">
                    {{invoice.lvmsId}}
                </a>
            </td>
            <td>
                <span>
                    {{invoice.invoiceNumber}}
                </span>
                <p-button *ngIf="invoice.fileId" icon="pi pi-download" (onClick)="downloadInvoiceFile(invoice)">
                </p-button>
            </td>
            <td>{{invoice.school.name}}</td>
            <td>{{invoice.studentName}}</td>
            <td>{{invoice.invoiceAmount}}</td>
            <td>{{invoice.dueDate}}</td>
            <td>{{invoice.currency.isoCode}}</td>
            <td>{{invoice.invoiceDate | date:'dd/MM/yyyy'}}</td>
            <td>{{invoice.comment}}</td>
            <td>
                {{invoice.totalPaidAmount}}
            </td>
            <td>
                {{invoice.lastPaymentDate | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{invoice.balance}}
            </td>
        </tr>
    </ng-template>
</p-table>